// import { Chat } from '@mui/icons-material';
import run, { generateResponse } from '../mainapi.js';
import React, {
    createContext, 
    useState
} from 'react'
import { query } from '../huggingFace.js';

export const dataContext = createContext()

export let user = {
    data: null,
    mime_type: null,
    imgUrl: null,
}

export let prevUser = {
    data: null,
    mime_type: null,
    prompt: null,
    imgUrl: null,
}



function UserContect({ children }) {

    // Chat seaction code start

    const [input, setInput] = useState("");
    const [showResult, setShowResult] = useState(false);
    const [loading, setLoading] = useState(false);
    const [resultData, setResultData] = useState("");
    const [recentPrompt, setRecentPropmt] = useState("");
    const [previousPrompt, setPerviousPrompt] = useState([]);
    const [copied, setCopied] = useState(false);
    const [isSpeaking, setIsSpeaking] = useState(false);
    const [popUp, setPopUp] = useState(false);
    const [popUps, setPopUps] = useState(false);
    const [feature, setFeature] = useState("chat");
    const [prevFeature, setPrevFeature] = useState("chat")
    const [genImgUrl, setGenImgUrl] = useState("")
    
    // Multi-turn conversation state
    const [conversationHistory, setConversationHistory] = useState([]);
    const [currentChatSession, setCurrentChatSession] = useState(null);

    const handleCopy = async () => {

        try {

            if (navigator.clipboard && navigator.clipboard.writeText) {

                await navigator.clipboard.writeText(resultData);

            } else {
                // Mobile & older browser fallback
                const textArea = document.createElement("textarea");
                textArea.value = resultData;
                textArea.style.position = "fixed";
                textArea.style.top = "0";
                textArea.style.left = "0";
                textArea.style.opacity = "0";
                document.body.appendChild(textArea);
                textArea.focus();
                textArea.select();
                textArea.setSelectionRange(0, 99999);
                document.execCommand("copy");
                document.body.removeChild(textArea);

            }
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);

        } catch (err) {

            console.error("Failed to copy: ", err);
            alert("Copying failed! Try manually selecting and copying.");

        }

    };

    const speakText = () => {

        const synth = window.speechSynthesis;
        const resultData = document.body.innerText; // Pura page ka text read karega

        if (synth.speaking) {

            synth.cancel(); // Pehle ka speech band kar do
            setIsSpeaking(false);
            return;

        }

        if (resultData !== "") {

            const utterance = new SpeechSynthesisUtterance(resultData);
            utterance.onend = () => setIsSpeaking(false);
            utterance.lang = "hi-IN";
            synth.speak(utterance);
            setIsSpeaking(true);

        }

    };


    function newChat() {
        setShowResult(false)
        setLoading(false)
        setConversationHistory([])
        setCurrentChatSession(null)
        setResultData("")
        setRecentPropmt("")
    }

    async function sent(input) {
        try {
            setResultData("");
            setPrevFeature(feature);
            setShowResult(true);
            setRecentPropmt(input);
            setLoading(true);
            
            // Add to previous prompts only if it's a new conversation
            if (conversationHistory.length === 0) {
                setPerviousPrompt(prev => [...prev, input]);
            }

            // Add user message to conversation history
            const userMessage = { role: "user", content: input, timestamp: Date.now() };
            setConversationHistory(prev => [...prev, userMessage]);

            if (feature === "genimg") {
                prevUser.prompt = input;
                try {
                    const imageBlob = await query();
                    if (imageBlob) {
                        const url = URL.createObjectURL(imageBlob);
                        setGenImgUrl(url);
                        setResultData("Image generated successfully!");
                    } else {
                        throw new Error("Failed to generate image");
                    }
                } catch (error) {
                    console.error("Image generation error:", error);
                    setResultData("Sorry, there was an error generating the image. Please try again.");
                }
            } else {
                try {
                    let response;
                    
                    // Use conversation history for context
                    const contextPrompt = conversationHistory
                        .map(msg => `${msg.role}: ${msg.content}`)
                        .join('\n') + `\nuser: ${input}`;
                    
                    if (user.data && user.mime_type) {
                        response = await generateResponse(contextPrompt, {
                            imageData: user.data,
                            mimeType: user.mime_type
                        });
                    } else {
                        response = await generateResponse(contextPrompt);
                    }

                    if (response) {
                        setResultData(response);
                        
                        // Add AI response to conversation history
                        const aiMessage = { role: "assistant", content: response, timestamp: Date.now() };
                        setConversationHistory(prev => [...prev, aiMessage]);
                        
                        // Store previous user data
                        prevUser.data = user.data;
                        prevUser.mime_type = user.mime_type;
                        prevUser.imgUrl = user.imgUrl;
                        prevUser.prompt = input;

                        // Reset current user data
                        user.data = null;
                        user.mime_type = null;
                        user.imgUrl = null;
                    } else {
                        throw new Error("No response received");
                    }
                } catch (error) {
                    console.error("Chat error:", error);
                    setResultData("Sorry, there was an error processing your request. Please try again.");
                }
            }

            setFeature("chat");
            setInput("");
        } catch (error) {
            console.error("Error in sent function:", error);
            setResultData("An unexpected error occurred. Please try again.");
        } finally {
            setLoading(false);
        }
    }

    const handleKeyDown = (event) => {

        if (event.key === "Enter") {

            sent(input);

        }

    };

    function handleImage(e) {

        setFeature("upimg")
        let file = e.target.files['0']

        let reader = new FileReader()
        reader.onload = (event) => {
            console.log(event);
            let base64 = event.target.result.split(",")[1]
            user.data = base64
            user.mime_type = file.type
            user.imgUrl = `data:${user.mime_type};base64,${user.data}`
        }
        console.log(file)
        reader.readAsDataURL(file)

    }

    // Chat seaction code end



    // Ai voice code start

    let [speaking, setSpeeking] = useState(false)
    let [aiSpeak, setAiSpeak] = useState("listening...")
    let [responseAi, setResponseAi] = useState(false)
    let [pausePlayback, setPausePlayback] = useState(false)


    async function aiReact(prompt) {
        try {
            // Check for "Who created you?" question directly
            const lowerPrompt = prompt.toLowerCase().trim();
            if (lowerPrompt === "who created you?" || 
                lowerPrompt.includes("who created you") ||
                lowerPrompt === "who made you?" ||
                lowerPrompt.includes("who made you") ||
                lowerPrompt.includes("who developed you") ||
                lowerPrompt.includes("your creator") ||
                lowerPrompt.includes("who built you")) {
                
                const directResponse = "I was created by ChatBox AI.";
                setAiSpeak(directResponse);
                speak(directResponse);
                setResponseAi(true);
                
                setTimeout(() => {
                    setSpeeking(false);
                    recognition.stop();
                    setTimeout(() => {
                        setReadyForNextQuestion(true);
                    }, 1000);
                }, 3000);
                
                return; // Exit early
            }
            
            let text = await run(prompt)
            
            // Remove markdown formatting and replace Google with ChatBox AI
            let newText = text
                .replace(/\*\*/g, '')
                .replace(/\*/g, '')
                .replace(/google/gi, "ChatBox AI")
                .replace(/Chatbox AI/g, "ChatBox AI"); // Fix any incorrect capitalization
            
            setAiSpeak(newText)
            
            // Only speak if not paused
            if (!pausePlayback) {
                speak(newText)
            }
            
            setResponseAi(true)
            
            // Automatically stop listening after responding
            // The timeout duration is based on the length of the response
            const speechDuration = Math.max(3000, newText.length * 80);
            
            setTimeout(() => {
                // Stop listening and reset for next interaction
                setSpeeking(false)
                recognition.stop()
                
                // Prepare for next question after a small delay
                setTimeout(() => {
                    setReadyForNextQuestion(true)
                }, 1000)
            }, speechDuration)
        } catch (error) {
            console.error("Error in aiReact:", error)
            setAiSpeak("Sorry, I encountered an error processing your request.")
            setResponseAi(true)
            speak("Sorry, I encountered an error processing your request.")
            setTimeout(() => {
                setSpeeking(false)
                recognition.stop()
                // Prepare for next question
                setTimeout(() => {
                    setReadyForNextQuestion(true)
                }, 1000)
            }, 4000)
        }
    }

    function speak(text) {
        const synth = window.speechSynthesis;
        
        // Cancel any ongoing speech
        synth.cancel();
        
        let utterance = new SpeechSynthesisUtterance(text)
        utterance.volume = 1;
        utterance.rate = 1;
        utterance.pitch = 1;
        
        // Detect if on mobile
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        
        // Set appropriate voice for the device
        if (isMobile) {
            utterance.lang = "en-US"; // More widely supported on mobile
        } else {
            utterance.lang = "hi-GB";
        }
        
        // Event handlers for speech synthesis
        utterance.onend = function() {
            setSpeeking(false);
        };
        
        utterance.onerror = function(event) {
            console.error("SpeechSynthesis error:", event);
            setSpeeking(false);
        };
        
        synth.speak(utterance);
    }

    function takeCommand(command) {

        if (command.includes("open") && command.includes("youtube")) {

            window.open("https://www.youtube.com/", "_blank")

            speak("opening Youtube")

            setAiSpeak("opening Youtube...")

            setTimeout(() => {
                setSpeeking(false)
            }, 3000)

        } else if (command.includes("open") && command.includes("google")) {

            window.open("https://www.google.com/", "_blank")

            speak("opening Google")

            setAiSpeak("opening Google...")

            setTimeout(() => {
                setSpeeking(false)
            }, 3000)

        } else if (command.includes("open") && command.includes("github")) {

            window.open("https://github.com/", "_blank")

            speak("opening Github")

            setAiSpeak("opening Github...")

            setTimeout(() => {
                setSpeeking(false)
            }, 3000)

        } else if (command.includes("open") && command.includes("gmail")) {

            window.open("https://mail.google.com/mail/u/0/#inbox", "_blank")

            speak("opening Gmail")

            setAiSpeak("opening Gmail...")

            setTimeout(() => {
                setSpeeking(false)
            }, 3000)

        } else if (command.includes("open") && command.includes("calendar")) {

            window.open("https://calendar.google.com/calendar/u/0/r", "_blank")

            speak("opening Calendar")

            setAiSpeak("opening Calendar...")

            setTimeout(() => {
                setSpeeking(false)
            }, 3000)

        } else if (command.includes("open") && command.includes("translate")) {

            window.open("https://translate.google.com/?sl=or&tl=en&op=translate", "_blank")

            speak("opening Translate")

            setAiSpeak("opening Translate...")

            setTimeout(() => {
                setSpeeking(false)
            }, 3000)

        } else if (command.includes("open") && command.includes("canva")) {

            window.open("https://www.canva.com/", "_blank")

            speak("opening Canva")

            setAiSpeak("opening Canva...")

            setTimeout(() => {
                setSpeeking(false)
            }, 3000)

        } else if (command.includes("open") && command.includes("instagram")) {

            window.open("https://www.instagram.com/accounts/login/?hl=en", "_blank")

            speak("opening Instagram")

            setAiSpeak("opening Instagram...")

            setTimeout(() => {
                setSpeeking(false)
            }, 3000)

        } else if (command.includes("open") && command.includes("facebook")) {

            window.open("https://www.facebook.com/login/?next=https%3A%2F%2Fwww.facebook.com%2F", "_blank")

            speak("opening Facebook")

            setAiSpeak("opening Facebook...")

            setTimeout(() => {
                setSpeeking(false)
            }, 3000)

        } else if (command.includes("date")) {

            let date = new Date().toLocaleString(undefined, { day: "numeric", month: "numeric", year: "numeric", hour: "numeric", minute: "numeric" })

            speak(date)

            setTimeout(() => {
                setSpeeking(false)
            }, 3000)

        }

        else {
            aiReact(command)
        }

    }

    // Add state for tracking readiness for next question
    const [readyForNextQuestion, setReadyForNextQuestion] = useState(true)

    // Modified speech recognition initialization
    let speechRecognition = window.speechRecognition || window.webkitSpeechRecognition
    let recognition = new speechRecognition()
    
    // Set continuous to false so it stops after one result
    recognition.continuous = false
    
    recognition.onresult = (e) => {
        let currentIndex = e.resultIndex
        let transcript = e.results[currentIndex][0].transcript
        
        setAiSpeak(transcript)
        // Set not ready for next question until current one is answered
        setReadyForNextQuestion(false)
        takeCommand(transcript.toLowerCase())
    }
    
    // Handle end of recognition
    recognition.onend = () => {
        // Only restart if still speaking (prevents immediate restart)
        if (speaking && !responseAi) {
            recognition.start()
        }
    }
    
    // Start listening when ready
    function startListening() {
        if (readyForNextQuestion) {
            setSpeeking(true)
            setResponseAi(false)
            setReadyForNextQuestion(false)
            try {
                recognition.start()
            } catch (error) {
                // If recognition is already started, stop it first
                recognition.stop()
                setTimeout(() => {
                    recognition.start()
                }, 200)
            }
        }
    }

    // Ai voice code end



    const data = {
        input,
        setInput,
        sent,
        showResult,
        setShowResult,
        loading,
        setLoading,
        resultData,
        setResultData,
        setRecentPropmt,
        recentPrompt,
        previousPrompt,
        setPerviousPrompt,
        newChat,
        recognition,
        speak,
        setSpeeking,
        speaking,
        aiSpeak,
        setAiSpeak,
        setResponseAi,
        responseAi,
        setCopied,
        copied,
        handleCopy,
        speakText,
        isSpeaking,
        setIsSpeaking,
        handleKeyDown,
        popUp,
        setPopUp,
        feature,
        setFeature,
        handleImage,
        prevFeature,
        setPrevFeature,
        genImgUrl,
        setGenImgUrl,
        popUps, 
        setPopUps,
        setPausePlayback,
        pausePlayback,
        readyForNextQuestion,
        setReadyForNextQuestion,
        startListening,
        // Multi-turn conversation states
        conversationHistory,
        setConversationHistory,
        currentChatSession,
        setCurrentChatSession
    }

    return (

        <>

            <dataContext.Provider value={data}>

                {children}

            </dataContext.Provider>

        </>

    )

}

export default UserContect
